import {TXHR} from '../../assets/constants/constansts.type';

export const ORDER_STATUS_CANCELED = 3;

export type TEticketSeatPos = {
    x: number;
    y: number;
    seat?: string;
    row?: string;
};

export type TEticketSeatMap = {
    width?: string;
    height?: string;
    stage?: {path?: string};
    area?: Record<string, {path?: string; title?: string; mine?: boolean; seats?: TEticketSeatPos[]}>;
};

export type TEticketEvent = {
    image?: string;
    imageColors?: string[];
    title: string;
    date?: string;
    timeOpen?: string;
    timeStart?: string;
    timeEnd?: string;
    location?: string;
    address?: string;
    seatMap?: TEticketSeatMap;
};

export type TEticketSeat = {
    seat?: string | number; // seat.x_title (כסא)
    row?: string | number; // seat.y_title (שורה)
    section?: string | number; // area.title (גוש)
    gate?: string | number; // אין מקור ב-DB עדיין (שער)
    aid?: number | string; // area.aid — לזיהוי הגוש של הכרטיס במפה
};

export type TEticketTicket = {
    title?: string;
    color?: string;
    seat?: TEticketSeat;
    inviterName?: string;
    oid: number;
    barcode: string;
    tid: number;
    qid: number;
    additionalInfo?: string;
    customFields?: {
        title: string;
        value: string;
    }[];
    scanned?: boolean;
    canceled?: boolean;
    scanTs?: number;
};

export type TEticketTransaction = {
    price: string;
    discount?: string;
    couponDiscount?: string;
    itemsCount?: number;
};

export type TEticketProducer = {
    packageName?: string;
    email?: string;
    phone?: string;
    billingId?: string;
    logo?: string;
};

export type TEticketLiveLink = {
    type: string;
    title: string;
    image?: string;
    url: string;
};

export type TEticketLive = {
    logo?: string;
    links: TEticketLiveLink[];
};

export type TEticketOrder = {
    oid: number;
    nameFirst?: string;
    nameLast?: string;
    email?: string;
    phone?: string;
    lang?: string;
    oCurrency?: string;
    ref?: string;
    source?: string;
    payMethod?: string;
    created?: string;
    newsletter?: number;
    status?: number; // ORDER_STATUS_CANCELED (3) = עסקה מבוטלת
};

export type TEticketLinks = {
    eventPage?: string;
    print?: string;
    cancel?: string;
    personalArea?: string;
    receipt?: string;
};

export type TCancelTicket = {
    allowed?: boolean;
    reason?: string;
};

export type TEticketData = {
    lang: string;
    event: TEticketEvent;
    tickets: TEticketTicket[];
    transaction?: TEticketTransaction;
    producer?: TEticketProducer;
    order?: TEticketOrder;
    links?: TEticketLinks;
    live?: TEticketLive;
    walletAllowed?: boolean;
    cancel?: TCancelTicket;
};

export type TEticketScanStatus = {
    scanned: 0 | 1;
    scanTs?: number;
};

export type TEticket = {
    data: TEticketData | null;
    oid: number | null;
    error: string | null;
    getETicketXHR: TXHR;
    getETicketScanStatusXHR: TXHR;
};
